import React from 'react'
import FontFile from '../shared/font-file'


const Word = (props) => {
  return <FontFile
    font={'stencil'}
    topOffset='0.05em'
    multiplier={1}
    {...props}
    borderColor={props.backCol}
  />
}

export default Word
